export enum REDIRECT_REASON_UPSERT_API_OPTIONS {
  CURRENCY_FIAT = 'currency:fiat',
  CURRENCY_CRYPTO = 'currency:crypto',
  DEFAULT = 'default',
}
